import React, { useEffect, useMemo, useState } from 'react';
import Header from '../components/Header';
import { BottomNavBar } from '../components/Header';
import useAttendanceStore from '../stores/attendanceStore';
import useAuthStore from '../stores/authStore';
import useScheduleStore from '../stores/scheduleStore';
import { formatDateToRussian } from '../utils/dateUtils';

function StudentAttendance() {
  const { user } = useAuthStore();
  const { fetchStudentAttendance, studentAttendance } = useAttendanceStore();
  const { fetchActualStudentSchedule } = useScheduleStore();
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  });

  const parseMonthRange = (ym) => {
    const [y, m] = ym.split('-').map(Number);
    const start = new Date(y, m - 1, 1);
    const end = new Date(y, m, 0);
    return {
      start: start.toISOString().slice(0, 10),
      end: end.toISOString().slice(0, 10)
    };
  };

  const [availableMonths, setAvailableMonths] = useState([]);

  // Discover months for student over current and next year
  useEffect(() => {
    async function discover() {
      if (!user?.studentId) return;
      const now = new Date();
      const start = new Date(now.getFullYear(), 0, 1).toISOString().slice(0,10);
      const end = new Date(now.getFullYear() + 1, 11, 31).toISOString().slice(0,10);
      const data = await fetchActualStudentSchedule({ studentId: user.studentId, startDate: start, endDate: end });
      const set = new Set();
      (data || []).forEach(d => { if (d.date) set.add(d.date.slice(0,7)); });
      const list = Array.from(set).sort((a,b)=> b.localeCompare(a));
      setAvailableMonths(list);
      if (list.length && !list.includes(selectedMonth)) setSelectedMonth(list[0]);
    }
    discover();
  }, [user, fetchActualStudentSchedule]);

  useEffect(() => {
    if (!user?.studentId) return;
    const { start, end } = parseMonthRange(selectedMonth);
    fetchStudentAttendance({ studentId: user.studentId, startDate: start, endDate: end, isAdmin: false });
  }, [user, selectedMonth, fetchStudentAttendance]);

  const rows = useMemo(() => {
    return (studentAttendance || []).map(a => {
      // Добавляем +1 день для корректного отображения
      const originalDate = new Date(a.date);
      originalDate.setDate(originalDate.getDate() + 1);
      const displayDate = originalDate.toISOString().slice(0, 10);
      
      return {
        id: a._id,
        date: displayDate,
        dateFormatted: formatDateToRussian(displayDate),
        time: a.startTime + (a.endTime ? `–${a.endTime}` : ''),
        subject: a.subject?.name || '',
        status: a.status
      };
    }).sort((a, b) => a.date.localeCompare(b.date) || a.time.localeCompare(b.time));
  }, [studentAttendance]);

  return (
    <div className='StudentAttendance'>
      <Header />
      <div className='Home__container'>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '12px 0 16px' }}>
          <span>Месяц:</span>
          <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)}>
            {(availableMonths.length ? availableMonths : [selectedMonth]).map(ym => {
              const [y,m] = ym.split('-').map(Number);
              const d = new Date(y, m-1, 1);
              const label = d.toLocaleDateString('ru-RU', { month: 'long', year: 'numeric' });
              return <option key={ym} value={ym}>{label}</option>;
            })}
          </select>
        </div>

          <table className='attendance-student-table' style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', padding: 8 }}>Дата</th>
              <th style={{ textAlign: 'left', padding: 8 }}>Время</th>
              <th style={{ textAlign: 'left', padding: 8 }}>Предмет</th>
              <th style={{ textAlign: 'left', padding: 8 }}>Статус</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id}>
                <td style={{ padding: 8 }}>{r.dateFormatted}</td>
                <td style={{ padding: 8 }}>{r.time}</td>
                <td style={{ padding: 8 }}>{r.subject}</td>
                  <td style={{ padding: 8 }}>
                    <span style={{
                      display: 'inline-block',
                      padding: '4px 10px',
                      borderRadius: 12,
                      background: r.status === 'present' ? '#e8f7ec' : r.status === 'absent' ? '#fdebea' : '#f3f3f7',
                      color: r.status === 'present' ? '#1a7f1a' : r.status === 'absent' ? '#c0392b' : '#777',
                      fontWeight: 600,
                      fontSize: 13,
                      minWidth: 64,
                      textAlign: 'center'
                    }}>
                      {r.status === 'present' ? 'Был' : r.status === 'absent' ? 'Не был' : '—'}
                    </span>
                  </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <BottomNavBar />
    </div>
  );
}

export default StudentAttendance;


